export const isPaytrailPayment = (paymentMethod?: string) => {
  return paymentMethod?.toLowerCase()?.includes('paytrail') || false;
};
